import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editor", "content"]

  connect() {
    const html = this.contentTarget.innerHTML
    if (!html || html === "<p></p>") return

    const editor = this.editorTarget

    if (editor.hasAttribute("connected")) {
      editor.value = html
    } else {
      editor.addEventListener("lexxy:initialize", () => {
        editor.value = html
      }, { once: true })
    }
  }
}
